module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vheader'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer text-center"
  }, [_c('p', [_c('span', [_vm._v("theme based on ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://blog.evanyou.me/"
    }
  }, [_vm._v("blog.evanyou.me")]), _vm._v(" "), _c('span', [_vm._v("| proudly powered by")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/sinchang/sublog"
    }
  }, [_vm._v("sublog")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.2@vue-loader/lib/template-compiler?{"id":"data-v-3b43d960"}!./~/.11.3.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 156
// module chunks = 1